export default "__VITE_ASSET__DCfGEvIy__"